import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/DiscussionCard.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots, faCodeBranch } from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "../helpers";
import UserLink from "./UserLink";

const DiscussionCard = ({ discussion, workflowId, index }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/workflow/${workflowId}/community/${discussion.id}`, {
      state: { discussion },
    });
  };

  return (
    <div onClick={handleCardClick} className={styles.card}>
      {/* Left Section */}
      <div className={styles.cardIcon}>
        <FontAwesomeIcon
          icon={discussion.type === "Code" ? faCodeBranch : faCommentDots}
        />
      </div>

      {/* Middle Section */}
      <div className={styles.cardContent}>
        <h4 className={styles.cardTitle}>{discussion.title}</h4>
        <p className={styles.cardSubtitle}>
          #{index + 1} opened {formatDate(discussion.created_at)} by{" "}
          <UserLink
            userId={discussion.user_id}
            userName={discussion.created_by}
          />
        </p>
      </div>

      {/* Right Section */}
      {discussion.num_of_responses > 0 && (
        <div className={styles.cardResponses}>
          <FontAwesomeIcon icon={faCommentDots} />
          <span>{discussion.num_of_responses}</span>
        </div>
      )}
    </div>
  );
};

export default DiscussionCard;
